/**
 * Nightwave — product.js
 * Beat page: license (variant) selection. Updates price, buy buttons,
 * license details panel and the ?variant= URL parameter.
 */
(() => {
  'use strict';

  const theme = (window.theme = window.theme || {});
  const strings = theme.strings || {};

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.variantInput = this.querySelector('[data-variant-id-input]');
      this.addEventListener('change', (event) => {
        const input = event.target.closest('.license-option__input');
        if (input) this.onLicenseChange(input);
      });

      const checked = this.querySelector('.license-option__input:checked');
      if (this.variantInput) {
        this.variantInput.disabled = false;
        if (checked) this.variantInput.value = checked.value;
      }
    }

    onLicenseChange(input) {
      const variantId = input.value;
      const available = input.dataset.available === 'true';
      const offerOnly = input.dataset.offerOnly === 'true';

      if (this.variantInput) this.variantInput.value = variantId;

      const price = this.querySelector('[data-product-price]');
      if (price && input.dataset.priceHtml) price.innerHTML = input.dataset.priceHtml;

      this.querySelectorAll('[data-license-panel]').forEach((panel) => {
        const active = panel.dataset.licensePanel === variantId;
        if (panel.hidden === !active) return;
        panel.hidden = !active;
        if (active && !theme.utils.prefersReducedMotion()) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });

      const buyButtons = this.querySelector('[data-buy-buttons]');
      const offerButton = this.querySelector('[data-offer-button]');
      if (buyButtons) buyButtons.hidden = offerOnly;
      if (offerButton) offerButton.hidden = !offerOnly;

      const addButton = this.querySelector('[data-add-to-cart]');
      const addText = this.querySelector('[data-add-to-cart-text]');
      const buyNow = this.querySelector('[data-buy-now]');
      [addButton, buyNow].forEach((button) => {
        if (button) button.disabled = !available;
      });
      if (addText) addText.textContent = available ? strings.addToCart : strings.soldOut;

      const error = this.querySelector('[data-form-error]');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url.toString());

      theme.events.emit('variant:change', { variantId, available });
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);
})();
